// extracted by mini-css-extract-plugin
export default {"inputNumber":"NumberValidatedInput_inputNumber__0TaC5"};